<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon small primary">
      <div class="inner"><i class="ti ti-user-plus"></i></div>
    </div>
    <span class="title ms-2">Ajouter un collaborateur</span>
  </div>
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>
<div class="modal-content">
  <form [formGroup]="userForm" class="d-flex flex-column align-items-center mt-3 w-100 gap-3">
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label class="form-label required">Rôle</label>
      <app-select [options]="rolesValues" formControlName="role" *ngIf="rolesValues"></app-select>
    </div>
    <div class="grid grid-2 gap-20 w-100">
      <div class="d-flex flex-column gap-2 form-group">
        <label class="form-label required">Prénom</label>
        <input class="form-control" type="text" formControlName="firstname"
          [class.is-invalid]="userForm.get('firstname').invalid && userForm.get('firstname').touched">
      </div>
      <div class="d-flex flex-column gap-2 form-group">
        <label class="form-label required">Nom</label>
        <input class="form-control" type="text" formControlName="lastname"
          [class.is-invalid]="userForm.get('lastname').invalid && userForm.get('lastname').touched">
      </div>
      <div class="d-flex flex-column gap-2 form-group">
        <label class="form-label required">Entreprise</label>
        <app-editable-input control="enterpriseName" [form]="userForm" [readonly]="true"></app-editable-input>
      </div>
      <div class="d-flex flex-column gap-2 form-group">
        <label>Fonction</label>
        <input class="form-control" type="text" formControlName="job"
          [class.is-invalid]="userForm.get('job').invalid && userForm.get('job').touched">
      </div>
      <div class="d-flex flex-column gap-2 form-group">
        <label>Téléphone fixe</label>
        <input class="form-control" type="text" formControlName="phone"
          [class.is-invalid]="userForm.get('phone').invalid && userForm.get('phone').touched">
      </div>
      <div class="d-flex flex-column gap-2 form-group">
        <label>Téléphone mobile</label>
        <input class="form-control" type="text" formControlName="mobile"
          [class.is-invalid]="userForm.get('mobile').invalid && userForm.get('mobile').touched">
      </div>
    </div>
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label class="form-label required">Email</label>
      <input class="form-control" type="text" formControlName="email"
        [class.is-invalid]="userForm.get('email').invalid && userForm.get('email').touched">
    </div>
  </form>
</div>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Annuler</button>
  <button class="button m primary confirm" (click)="createUser()" type="button">Confirmer<ion-spinner *ngIf="validating"
      color="light" name="dots"></ion-spinner></button>
</div>